module.exports = __webpack_public_path__ + "static/media/k12_site_buy_header.35a4c4d3.jpg";